/**
 * Escape HTML SSOT del front-promoter.
 *
 * Único punto para neutralizar `& < > " '` antes de inyectar texto de usuario o
 * de backend en innerHTML / atributos. Cubre tanto contenido de elemento como
 * valores de atributo entre comillas dobles (escapa `"` y `'`).
 *
 * Reemplaza las copias que vivían sueltas en app.js, views/compartir.js y
 * views/seccion-mis-pagos.js (mismo objetivo, dos implementaciones distintas).
 */
const MAPA_ESCAPE_HTML = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export function escapeHtml(valor) {
    return String(valor == null ? '' : valor).replace(/[&<>"']/g, c => MAPA_ESCAPE_HTML[c]);
}
